import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Learning } from '@shared/entities/learning';
import { ApiService } from '@shared/services';
import { Observable, catchError, map, of, tap, switchMap, take } from 'rxjs';
import { LearningService } from './learning.service';
import { AuthenticationService } from '../authentication.service';
import { environment } from '@environments/environment';

const LOG_PREFIX = '[Api][LearningDetail] ';

@Injectable({
  providedIn: 'root'
})
export class LearningDetailService extends ApiService<Learning> {
  constructor(
    private http: HttpClient,
    private _learningService: LearningService,
    private _authenticationService: AuthenticationService
  ) {
    const masterUrl = '/learning';
    const detailUrl = '/learning';
    super(Learning, masterUrl, detailUrl, undefined, 'learning-form');
  }

  findLearning(id: string): Observable<Learning | null> {
    return this.findOne(id).pipe(
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'findLearning error', error);
        return of(null);
      })
    );
  }

  findByFilter(id: string): Observable<Learning | null> {
    this.logger.debug(LOG_PREFIX + `findByFilter with id: ${id}`);

    this.setUrlParameter('id', id);

    return this.paginate(Learning, 1, 1).pipe(
      map((paginate) => {
        if (paginate && paginate.data && paginate.data.length > 0) {
          return paginate.data[0];
        }
        return null;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'findByFilter error', error);
        return of(null);
      })
    );
  }

  toggleFavorite(learningId: string): Observable<string | null> {
    this.logger.debug(LOG_PREFIX + `toggleFavorite with learningId: ${learningId}`);

    return this._authenticationService.currentUser.pipe(
      take(1),
      switchMap(() => {
        const body = {
          learningId: learningId
        };

        return this.http.post<any>(`${environment.apiBaseUrl}/favorite-learning`, body as any).pipe(
          tap(() => {
            this.logger.debug(LOG_PREFIX + 'toggleFavorite success');
            this._learningService.refreshFilters();
          }),
          map(() => 'OK'),
          catchError((error) => {
            this.logger.error(LOG_PREFIX + 'toggleFavorite error', error);
            return of(null);
          })
        );
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'toggleFavorite auth error', error);
        return of(null);
      })
    );
  }

  deleteLearning(id: string): Observable<boolean | null> {
    this.logger.debug(LOG_PREFIX + `deleteLearning with id: ${id}`);
    return this.http
      .delete<any>(`${environment.apiBaseUrl}/learning`, { body: { id } })
      .pipe(
        map(() => {
          this.logger.debug(LOG_PREFIX + 'deleteLearning success');
          this._learningService.refreshFilters();
          return true;
        }),
        catchError((error) => {
          this.logger.error(LOG_PREFIX + 'deleteLearning error', error);
          return of(error);
        })
      );
  }
}
